<template>
  <div class="top-adsense-container" style="min-height: 100px; text-align: center; margin-bottom: 20px;">
    <!-- ch1_ReviewStream_top -->
    <ins class="adsbygoogle"
         style="display:block"
         data-ad-client="ca-pub-5817088155848383"
         data-ad-slot="9808450446"
         data-ad-format="auto"
         data-full-width-responsive="true"></ins>
  </div>
</template>

<script>
import { onMounted } from 'vue'

export default {
  name: 'TopAdSense',
  setup() {
    onMounted(() => {
      // Load the AdSense script if it doesn't strictly exist
      // We check for the script source to avoid simple duplication
      const scriptSrc = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-5817088155848383"
      if (!document.querySelector(`script[src="${scriptSrc}"]`)) {
        const adScript = document.createElement('script')
        adScript.async = true
        adScript.src = scriptSrc
        adScript.crossOrigin = "anonymous"
        document.head.appendChild(adScript)
      }

      // Initialize the ad
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({})
      } catch (e) {
        console.error('AdSense load error:', e)
      }
    })
  }
}
</script>

<style scoped>
.top-adsense-container {
  width: 100%;
  overflow: hidden;
}
</style>
